import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import { StatsBar, PlatformOverview, MarketOpportunity, TokenEconomics } from "@/components/Sections1";
import { TechMarquee, InstitutionalTech, Regulatory, Performance, ResponsibleInvesting } from "@/components/Sections2";
import { InvestmentProcess, Leadership, Roadmap } from "@/components/Sections3";
import Trust from "@/components/Trust";
import {
  AssetClassesGrid, PlatformMetrics, SecurityAndCompliance,
  ForInstitutions, EcosystemStrip, ReferralBanner,
} from "@/components/HomeSections";
import { FAQ, FinalCTA } from "@/components/FaqCta";
import Footer from "@/components/Footer";

export default function Home({ onCta }) {
  return (
    <>
      <Navbar onCta={onCta} />
      <main>
        <Hero onExplore={onCta} onInvest={onCta} />
        <StatsBar />
        <Trust />
        <AssetClassesGrid />
        <TechMarquee />
        <PlatformOverview />
        <PlatformMetrics />
        <MarketOpportunity />
        <TokenEconomics />
        <SecurityAndCompliance />
        <InstitutionalTech />
        <ForInstitutions />
        <Regulatory />
        <Performance />
        <InvestmentProcess />
        <Leadership />
        <ResponsibleInvesting />
        <EcosystemStrip />
        <Roadmap />
        <ReferralBanner />
        <FAQ />
        <FinalCTA onGetStarted={onCta} onDemo={onCta} />
      </main>
      <Footer />
    </>
  );
}
